import { Flex, Text } from "@chakra-ui/react";

const DashboardFooter = () => (
  <Flex
    as="footer"
    w="full"
    minH="64px"
    px={4}
    py={{ base: 5, md: 3 }}
    alignItems="center"
    justifyContent="center"
    flexShrink={0}
  >
    <Text
      color="gray.500"
      textAlign="center"
      fontFamily="font4"
      fontSize={{ base: "12px", md: "14px" }}
      letterSpacing="0.08em"
    >
      Your wedding will be great, and life after would be even greater.
    </Text>
  </Flex>
);

export default DashboardFooter;
